/* ============================================================
   Photo slate designer — products tagged customslate*.

   Two layer modes, set per variant by the section:
     under — the slate face is transparent in the base asset, so the photo
             is drawn first and the mockup goes over it. The real slate edge
             (and the heart's outline) does the masking, so odd shapes need
             no clip path.
     over  — the artwork is opaque, so the photo is drawn on top inside a
             fixed box.

   data-shape="circle" (bauble designer, circle123) clips the zone to a
   circle/ellipse instead of a box, in the preview and in both print files.
   data-poly="x,y x,y ..." (angel123) clips to any outline instead; points
   are fractions of the zone, matching the zone's CSS clip-path.

   The DOM preview and the print canvases share the same geometry maths, so
   what the customer positions is exactly what gets printed.
   ============================================================ */
(function () {
  "use strict";

  var stage = document.querySelector("[data-sl-stage]");
  if (!stage) return;

  var baseImg = stage.querySelector(".sl__base");
  var zoneEl = stage.querySelector("[data-sl-zone]");
  var photoEl = stage.querySelector("[data-sl-photo]");
  var hintEl = stage.querySelector("[data-sl-hint]");

  var drop = document.querySelector("[data-sl-drop]");
  var dropLabel = document.querySelector("[data-sl-drop-label]");
  var fileInput = document.querySelector("[data-sl-file]");
  var transformBox = document.querySelector("[data-sl-transform]");
  var zoom = document.querySelector("[data-sl-zoom]");
  var zoomOut = document.querySelector("[data-sl-zoomout]");
  var rot = document.querySelector("[data-sl-rot]");
  var rotOut = document.querySelector("[data-sl-rotout]");

  var zone = (stage.getAttribute("data-zone") || "0,0,100,100").split(",").map(Number);
  var mode = stage.getAttribute("data-mode") || "under";
  var shape = stage.getAttribute("data-shape") || "rect";
  var item = stage.getAttribute("data-item") || "slate";
  var poly = (stage.getAttribute("data-poly") || "").trim().split(/\s+/).filter(Boolean)
    .map(function (p) { return p.split(",").map(Number); });
  var clipped = shape === "circle" || poly.length > 2;

  var st = { file: null, url: null, natW: 0, natH: 0, scale: 1, rot: 0, flip: 1, fx: 0, fy: 0 };

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  /* Cover-fit, then offset, then rotate about the photo's own centre.
     fx/fy are fractions of the drawn size so they survive any rescale. */
  function box(zw, zh) {
    var cover = Math.max(zw / st.natW, zh / st.natH);
    var w = st.natW * cover * st.scale;
    var h = st.natH * cover * st.scale;
    return {
      w: w, h: h,
      cx: zw / 2 + clamp(st.fx, -0.5, 0.5) * w,
      cy: zh / 2 + clamp(st.fy, -0.5, 0.5) * h
    };
  }

  function layout() {
    if (!st.url || !st.natW) return;
    var zw = zoneEl.clientWidth, zh = zoneEl.clientHeight;
    if (!zw || !zh) return;
    var b = box(zw, zh);
    photoEl.style.width = b.w + "px";
    photoEl.style.height = b.h + "px";
    photoEl.style.left = "0px";
    photoEl.style.top = "0px";
    photoEl.style.transform =
      "translate(" + (b.cx - b.w / 2) + "px," + (b.cy - b.h / 2) + "px)" +
      " rotate(" + st.rot + "deg) scaleX(" + st.flip + ")";
  }

  function syncOutputs() {
    if (zoomOut) zoomOut.textContent = Math.round(st.scale * 100) + "%";
    if (rotOut) rotOut.textContent = Math.round(st.rot) + "°";
  }

  function resetTransform() {
    st.scale = 1; st.rot = 0; st.flip = 1; st.fx = 0; st.fy = 0;
    if (zoom) zoom.value = 100;
    if (rot) rot.value = 0;
    syncOutputs();
    layout();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function setPhoto(file) {
    if (!file || !/^image\//.test(file.type)) return;
    if (st.url) URL.revokeObjectURL(st.url);
    st.file = file;
    st.url = URL.createObjectURL(file);
    var probe = new Image();
    probe.onload = function () {
      st.natW = probe.naturalWidth;
      st.natH = probe.naturalHeight;
      photoEl.src = st.url;
      photoEl.hidden = false;
      if (hintEl) hintEl.hidden = true;
      if (transformBox) transformBox.hidden = false;
      if (dropLabel) dropLabel.innerHTML = "<strong>" + escapeHtml(file.name) + "</strong> — tap to change";
      resetTransform();
    };
    probe.src = st.url;
  }

  if (drop) {
    drop.addEventListener("click", function () { fileInput.click(); });
    drop.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInput.click(); }
    });
    ["dragenter", "dragover"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-over"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("is-over"); });
    });
    drop.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) setPhoto(e.dataTransfer.files[0]);
    });
  }
  if (fileInput) fileInput.addEventListener("change", function () { if (this.files && this.files[0]) setPhoto(this.files[0]); });
  if (zoom) zoom.addEventListener("input", function () { st.scale = +this.value / 100; syncOutputs(); layout(); });
  if (rot) rot.addEventListener("input", function () { st.rot = +this.value; syncOutputs(); layout(); });

  document.querySelectorAll("[data-sl-rot-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      st.rot = ((st.rot + +b.getAttribute("data-sl-rot-step") + 180 + 360) % 360) - 180;
      if (rot) rot.value = st.rot;
      syncOutputs(); layout();
    });
  });
  var flipBtn = document.querySelector("[data-sl-flip]");
  if (flipBtn) flipBtn.addEventListener("click", function () { st.flip *= -1; layout(); });
  var resetBtn = document.querySelector("[data-sl-reset]");
  if (resetBtn) resetBtn.addEventListener("click", resetTransform);

  /* drag to reposition — pointer events cover mouse and touch */
  (function () {
    var dragging = false, sx = 0, sy = 0, startFx = 0, startFy = 0, b = null;
    var surface = mode === "under" ? stage : zoneEl;
    surface.addEventListener("pointerdown", function (e) {
      if (!st.url) return;
      dragging = true;
      surface.setPointerCapture(e.pointerId);
      sx = e.clientX; sy = e.clientY;
      startFx = st.fx; startFy = st.fy;
      b = box(zoneEl.clientWidth, zoneEl.clientHeight);
      stage.classList.add("is-dragging");
    });
    surface.addEventListener("pointermove", function (e) {
      if (!dragging || !b) return;
      st.fx = clamp(startFx + (e.clientX - sx) / b.w, -0.5, 0.5);
      st.fy = clamp(startFy + (e.clientY - sy) / b.h, -0.5, 0.5);
      layout();
    });
    ["pointerup", "pointercancel"].forEach(function (ev) {
      surface.addEventListener(ev, function () {
        dragging = false;
        stage.classList.remove("is-dragging");
      });
    });
  })();

  window.addEventListener("resize", layout);
  if (baseImg && !baseImg.complete) baseImg.addEventListener("load", layout);
  layout();

  /* ---------------- canvas output ---------------- */

  function drawPhotoInto(ctx, img, x, y, w, h) {
    var b = box(w, h);
    ctx.save();
    ctx.beginPath();
    if (poly.length > 2) {
      poly.forEach(function (p, i) { ctx[i ? "lineTo" : "moveTo"](x + p[0] * w, y + p[1] * h); });
      ctx.closePath();
    } else if (shape === "circle") ctx.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
    else ctx.rect(x, y, w, h);
    ctx.clip();
    ctx.translate(x + b.cx, y + b.cy);
    ctx.rotate(st.rot * Math.PI / 180);
    ctx.scale(st.flip, 1);
    ctx.drawImage(img, -b.w / 2, -b.h / 2, b.w, b.h);
    ctx.restore();
  }

  function loadImage(src, cb) {
    var i = new Image();
    i.crossOrigin = "anonymous";
    i.onload = function () { cb(i); };
    i.onerror = function () { cb(null); };
    i.src = src;
  }

  function buildPreview(cb) {
    loadImage(stage.getAttribute("data-base"), function (base) {
      if (!base) { cb(null); return; }
      var S = base.naturalWidth || 1200;
      var c = document.createElement("canvas");
      c.width = S; c.height = S;
      var ctx = c.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, S, S);
      var z = { x: zone[0] / 100 * S, y: zone[1] / 100 * S, w: zone[2] / 100 * S, h: zone[3] / 100 * S };

      function done() {
        c.toBlob(function (b) {
          cb(b ? new File([b], item + "-preview.png", { type: "image/png" }) : null);
        }, "image/png", 0.95);
      }

      loadImage(st.url, function (p) {
        if (mode === "under") {
          if (p) drawPhotoInto(ctx, p, z.x, z.y, z.w, z.h);
          ctx.drawImage(base, 0, 0, S, S);   /* mockup masks the photo */
        } else {
          ctx.drawImage(base, 0, 0, S, S);
          if (p) drawPhotoInto(ctx, p, z.x, z.y, z.w, z.h);
        }
        done();
      });
    });
  }

  /* Production artwork: just the customer's photo, cropped exactly as
     positioned, at the print zone's aspect ratio. Circles and outlines
     keep a transparent background outside the shape. */
  function buildLayout(cb) {
    var PW = 1200;
    var PH = Math.round(PW * (zone[3] / zone[2]));
    var c = document.createElement("canvas");
    c.width = PW; c.height = PH;
    var ctx = c.getContext("2d");
    if (!clipped) {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, PW, PH);
    }
    loadImage(st.url, function (p) {
      if (p) drawPhotoInto(ctx, p, 0, 0, PW, PH);
      c.toBlob(function (b) {
        cb(b ? new File([b], item + "-print-layout.png", { type: "image/png" }) : null);
      }, "image/png", 0.95);
    });
  }

  /* ---------------- add to basket ---------------- */

  var form = document.querySelector("[data-slate-form]");
  if (!form) return;
  var busy = false;

  form.addEventListener("submit", function (e) {
    if (busy) return; /* second pass — let the real post through */
    e.preventDefault();
    if (!st.file) { alert("Please upload a photo for your " + item + "."); return; }

    busy = true;
    var btn = form.querySelector("[data-sl-save]");
    if (btn) { btn.disabled = true; btn.classList.add("is-busy"); }

    function attach(sel, file, next) {
      var input = form.querySelector(sel);
      if (input && file) {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        input.disabled = false;
      }
      next();
    }

    attach("[data-sl-photo-file]", st.file, function () {
      buildLayout(function (layoutFile) {
        attach("[data-sl-layout-file]", layoutFile, function () {
          buildPreview(function (preview) {
            attach("[data-sl-preview-file]", preview, function () { form.submit(); });
          });
        });
      });
    });
  });
})();
